import httpClient from '@/shared/http-eserv-client';

const getAccountingOpenInvoices = () => httpClient.get("/ApplicationRequests/AllInvoices?$filter=invoiceStatus eq 'Pending Payment' or invoiceStatus eq 'Pending Credit Allocation'");
const getAccountingClosedInvoices = () => httpClient.get("/ApplicationRequests/AllInvoices?$filter=invoiceStatus eq 'Paid' or invoiceStatus eq 'Cancelled' or InvoiceStatus eq 'Paid (Refund)' or InvoiceStatus eq 'Cancelled-WO'");
const getAccountingHistoricalInvoices = () => httpClient.get('/ApplicationRequests/AllHistoricals');
const getTransactionRefunds = () => httpClient.get('/ApplicationRequests/AllRefunds');
const getAccountingUserCredits = () => httpClient.get('/UserCredits');
const getAccountingUserCreditById = (userId) => httpClient.get(`/UserCredits?userId=${userId}`);
const getInvoicePDF = (accessToken, userId, invoiceId) => httpClient.get(`/Invoices/pdf?securityToken=${accessToken}&userId=${userId}&invoiceId=${invoiceId}`);
const getInvoiceById = (invoiceId) => httpClient.get(`/invoices/${invoiceId}?$expand=applicationRequest`)
// api is returning invoice in an array for some reason.
  .then((resp) => resp.data[0]).catch((error) => {
    console.error(error);
    return null;
  });
const getRefndInvoiceBySourceId = (invoiceId) => httpClient.get(`/invoices?$filter=sourceInvoiceId eq ${invoiceId}&$expand=applicationRequest`)
// api is returning invoice in an array for some reason.
  .then((resp) => resp.data[0]).catch((error) => {
    console.error(error);
    return null;
  });
const getInvoiceByNumber = (invoiceNumber) => httpClient
  .get(`/invoices?$expand=applicationRequest&$filter=invoiceNumber eq '${invoiceNumber}'`)
  // api is returning invoice in an array for some reason.
  .then((resp) => resp.data[0]).catch((error) => {
    console.error(error);
    return null;
  });
const getInvoiceDetails = (invoiceId) => httpClient.get(`/invoices/${invoiceId}?$select=invoiceNumber&$expand=invoiceDetails`)
  .then((resp) => resp.data).catch((error) => {
    console.error(error);
    return null;
  });
const getAccountingPaymentTypes = () => httpClient.get('/PaymentMethods/paymentTypes');
const getAccountingCreditCardTypes = () => httpClient.get('/PaymentMethods/CreditCardTypes');

const processInvoiceApprove = (data) => httpClient.post('/invoices/Approve', data);
const processInvoiceResetPaymentType = (data) => httpClient.post('/invoices/ResetPaymentType', data);
const processInvoiceCancel = (data) => httpClient.post('/invoices/Cancel', data);
const processInvoiceWO = (data) => httpClient.post('/invoices/WriteOff', data);
const processInvoiceRefund = (data) => httpClient.post('/invoices/Refund', data);
const processUserCredit = (data) => httpClient.post('/UserCredits', data);
const deleteUserCredit = (userCreditId) => httpClient.delete(`/UserCredits/${userCreditId}`);

const processInvoiceGroup = (data) => httpClient.post('/autorecoverygroups/grouping', data);

const uploadInvoiceDocument = (document) => httpClient.post('/Invoices/UploadDocument', document);

const getDocumentFile = (accessToken, userId, documentId) => httpClient.get(`/Documents/open?securityToken=${accessToken}&userId=${userId}&documentId=${documentId}`);

const getProducts = () => httpClient.get('/Products');
const getProductsByCategory = (category) => httpClient.get(`/Products/?$filter=category eq '${category}'`);
const getProductTypeList = () => httpClient.get(`/Products/?$filter=category ne 'Miscellaneous Fee' and GroupLevel eq 1`);
const getPriceByProductID = (productId) => httpClient.get(`/Prices/${productId}`);
const setInvoice = (data) => httpClient.post('invoices/miscellaneous', data);
const getReceiptPDF = (accessToken, userId, orderId, invoiceId) => httpClient.get(`/invoices/receipt?securityToken=${accessToken}&userId=${userId}&orderId=${orderId}&invoiceId=${invoiceId}`);

export {
  getAccountingOpenInvoices,
  getAccountingClosedInvoices,
  getAccountingHistoricalInvoices,
  getAccountingUserCredits,
  getAccountingUserCreditById,
  getTransactionRefunds,
  getInvoicePDF,
  getInvoiceById,
  getInvoiceByNumber,
  getInvoiceDetails,
  getAccountingPaymentTypes,
  getAccountingCreditCardTypes,
  processInvoiceApprove,
  processInvoiceGroup,
  processInvoiceResetPaymentType,
  processInvoiceCancel,
  processInvoiceWO,
  processInvoiceRefund,
  processUserCredit,
  deleteUserCredit,
  uploadInvoiceDocument,
  getDocumentFile,
  getRefndInvoiceBySourceId,
  getProducts,
  getProductsByCategory,
  getProductTypeList,
  getPriceByProductID,
  setInvoice,
  getReceiptPDF,
};
